const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const API_KEY = process.env.REACT_APP_API_KEY || '';

export interface CustomerInfo {
    first_name: string | null;
    last_name: string | null;
    location_name: string | null;
    has_iban: boolean;
    iban_last5: string | null;
    bank_country: string | null;
    account_number: string | null;
    swift: string | null;
    account_holder_name: string | null;
}

export interface SubmitPayload {
    account_holder_name: string;
    iban: string;
    bic: string;
    bank_country: string;
    account_number: string;
}

export interface SubmitOk {
    ok: true;
    iban_last5: string;
    circuit: string;
}

export interface SubmitError {
    ok: false;
    errors?: Record<string, string>;
    message?: string;
    circuit?: string;
}

export interface FetchOk {
    ok: true;
    data: CustomerInfo;
}

export interface FetchError {
    ok: false;
    status: number;
    message: string;
}

interface RawResponse {
    status: number;
    body: any;
}

async function call(token: string, init?: RequestInit): Promise<RawResponse> {
    const res = await fetch(`${API_BASE}/bank/customer/${encodeURIComponent(token)}`, {
        ...init,
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': API_KEY,
            ...(init?.headers || {}),
        },
    });
    const body = await res.json().catch(() => ({}));
    return { status: res.status, body };
}

export async function fetchCustomer(token: string): Promise<FetchOk | FetchError> {
    const { status, body } = await call(token);
    if (status === 200 && body?.data) {
        return { ok: true, data: body.data as CustomerInfo };
    }
    return { ok: false, status, message: body?.message || `HTTP ${status}` };
}

export async function submitIban(
    token: string,
    payload: SubmitPayload,
): Promise<SubmitOk | SubmitError> {
    const { status, body } = await call(token, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    if (status === 200 && body?.data?.ok) {
        return { ok: true, iban_last5: body.data.iban_last5, circuit: body.data.circuit };
    }
    return {
        ok: false,
        errors: body?.data?.errors,
        message: body?.message || `Errore HTTP ${status}`,
        circuit: body?.data?.circuit,
    };
}
